export default __webpack_public_path__ + "static/media/Dave.8dd9523d.jpg";